import className from 'classnames/bind';
import styles from './PostBody.module.scss';
import { WordPressBlocksViewer } from '@faustwp/blocks';
import { PostInfo, RelatedPosts } from '@/components';
import { useEffect, useRef, useState } from 'react';

let cx = className.bind(styles);

export function PostBody({ blocks, date, author, tags, categories, relatedPosts }) {
	const [wordCount, setWordCount] = useState(null);
	const postArticle = useRef(null);

	function getText(el) {
		let text = '';
		var length = el.childNodes.length;
		for (var i = 0; i < length; i++) {
			var node = el.childNodes[i];
			if (node.nodeType != 8) {
				text += node.nodeType != 1 ? ` ${node.nodeValue}` : getText(node);
			}
		}
		return text;
	}

	useEffect(() => {
		if (postArticle.current) {
			setWordCount(getText(postArticle.current).split(/\s+/).length);
		}
	}, []);

	return (
		<>
			<div className={cx(['post-container'])}>
				<div className={cx(['post-details-and-controls'])}>
					<PostInfo date={date} author={author} wordCount={wordCount} />
				</div>
				<article className={cx(['post-article'])} ref={postArticle}>
					<WordPressBlocksViewer blocks={blocks} />
				</article>
        {/* <div className={cx(['post-tags'])}>
          {tags?.map(tag => (
            <Button className={cx(['post-tag'])} href={tag.uri} outlined={true}>
              {tag.name.charAt(0).toUpperCase() + tag.name.slice(1)}
            </Button>
          ))}
        </div> */}
			</div>
			<RelatedPosts relatedPosts={relatedPosts} categories={categories} />
		</>
	);
}
